<template>
  <!-- can-cancel = ['escape', 'x', 'outside'] si se quiere que cierre  por cualqiera de esos [] caso contrario -->
  <b-modal :active.sync="isModalActive" :width="680" scroll="keep" :can-cancel="[]">
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
    <div class="rounded-lg bg-white overflow-hidden border border-[#E4E6EB] shadow-lg">
      <!-- HEADER estilo Meta -->
      <header class="flex justify-between items-center px-4 py-3 border-b border-[#E4E6EB] bg-white">
        <div class="flex-1 min-w-0">
          <h2 class="text-base font-semibold text-gray-900 break-words whitespace-normal">
            {{ title }}
          </h2>
        </div>
        <button
          v-if="!processingData"
          @click="isModalActive = false"
          class="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-1"
          :aria-label="$t('close')"
        >
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
          </svg>
        </button>
      </header>

      <!-- CONTENIDO -->
      <div class="px-4 py-4 space-y-4 bg-white">

        <SelectedElementsSummary v-if="data"
          :statuses="data.statuses"
          :selected-entities="data.selectedEntities"
          :type-status="data.typeStatus"
          :design-data="data.designData"
          :layer="data.layer"
        />

        <UpdateStatusesForm v-if="data && data.action === 'register'"
          ref="refUpdateStatusesForm"
          :type-register="data.typeRegister"
          :type-status="data.typeStatus"
          :statuses="data.statuses"
          :permitted-statuses="data.permittedStatuses"
          :selected-entities="data.selectedEntities"
          :allowed-select-multiple="data.allowedSelectMultiple"
        />

        <div v-if="data && data.action !== 'register'" class="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <p class="text-sm text-blue-800">
            <span v-if="data.action === 'revert'">
              {{ $t(data.typeStatus === 'progress' ? 'revert_selected_progress_status_message' : 'revert_selected_incident_status_message') }}
            </span>
            <span v-else-if="data.action === 'clear'">
              {{ $t(data.typeStatus === 'progress' ? 'clear_selected_progress_status_message' : 'clear_selected_incident_status_message') }}
            </span>
            <span v-else>
              {{ $t('apply_selected_action_message') }}
            </span>
          </p>
        </div>

      </div>

      <!-- FOOTER estilo Meta -->
      <footer class="px-4 py-3 border-t border-[#E4E6EB] bg-white">
        <div class="w-full flex items-center gap-2" :class="processingData ? 'justify-center' : 'justify-between'">
          <v-button v-if="!processingData" color="grey" icon="door-closed" size="is-small" @click="isModalActive = false">{{ $t('close') }}</v-button>
          <v-button v-if="!processingData" @click="handleClick()" icon="plus" size="is-small">
            {{ data && data.action === 'register' ? $t('apply_status') : $t('execute_action') }}
          </v-button>
          <v-button-processing v-if="processingData" />
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import UpdateStatusesForm from '../forms/UpdateStatusesForm.vue'
import SelectedElementsSummary from '../summaries/SelectedElementsSummary.vue'

export default {
  name: "UpdateStatusesModal",

  components: {
    UpdateStatusesForm,
    SelectedElementsSummary
  },

  props: {

  },

  data() {
    return {
      isModalActive: false,
      isLoading: false,
      processingData: false,

      data: null,
      title: '',
      selectedEntities: [],
    }
  },

  computed: {

  },

  created() {
  },

  methods: {
    async handleClick() {
      this.processingData = true;

      const data = (this.data.action === 'register')
        ? this.$refs.refUpdateStatusesForm.applyStatus()
        : {
          action: this.data.action,
          typeStatus: this.data.typeStatus,
          changeEntities: this.data.selectedEntities,
        };

      this.processingData = false;

      if (typeof data !== 'undefined') {
        this.$emit('epc-update-selected-status', data);
        this.hide();
      }
    },

    show(data) {
      this.data = data;

      if (data.typeRegister === 'progress') {
        if (data.action === 'register') {
          this.title = data.typeStatus === 'progress'
            ? this.$t('progress_record')
            : this.$t('incident_record');
        } else if (data.action === 'revert') {
          this.title = this.$t('back_to_previous_status');
        } else if (data.action === 'clear') {
          this.title = data.typeStatus === 'progress'
            ? this.$t('clear_status')
            : this.$t('clear_incident');
        }
      } else {
        this.title = this.$t('mark_issue');
      }

      this.isModalActive = true;
    },

    hide() {
      this.data = null;

      this.isModalActive = false;

    }
  }
};
</script>

<style scoped>
  /* Oculta los botones para aumentar los inputs numéricos */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  input[type="number"] {
    -moz-appearance: textfield; /* Firefox */
    appearance: textfield; /* Estándar */
  }

  /* Scrollbar personalizado estilo Material Design 3 */
  .custom-scrollbar::-webkit-scrollbar {
    width: 6px;
  }

  .custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 3px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
</style>
